import { useCallback, useState } from 'react';
import apiClient from '@utils/api-client';
import useGenericEventProcessor from '@hooks/processors/use-generic-event-processor';
import { apiInternalGenericEventPath } from '../../routes';
function usePatchGenericEvent() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState();
    const [result, setResult] = useState();
    const { processGenericEvent } = useGenericEventProcessor();
    const save = useCallback((params) => {
        return new Promise((resolve, reject) => {
            var _a, _b;
            const controller = new AbortController();
            setSaving(true);
            const genericEventInfo = {
                title: params.genericEvent.title,
                description: params.genericEvent.description,
                address: params.genericEvent.address,
                contact_name: params.genericEvent.contactName,
                contact_phone: params.genericEvent.contactPhone,
                duration: !params.genericEvent.allDay ? params.genericEvent.durationMins : null,
                time_zone_override: params.genericEvent.timeZone,
                conflictable: params.genericEvent.conflictable,
                technician_ids: params.genericEvent.technicianIds,
                start_date: params.genericEvent.allDay ? params.genericEvent.start.startOf('day').toISOString() : params.genericEvent.start.toISOString(),
                end_date: params.genericEvent.allDay ? params.genericEvent.end.endOf('day').toISOString() : null,
                all_day: params.genericEvent.allDay
            };
            apiClient
                .patch(apiInternalGenericEventPath(params.genericEvent.id), undefined, {
                params: {
                    generic_event: genericEventInfo,
                    updateFutureEvents: (_a = params.updateFutureEvents) !== null && _a !== void 0 ? _a : false,
                    originalStart: ((_b = params.originalStart) !== null && _b !== void 0 ? _b : params.genericEvent.start).toISOString()
                },
                signal: controller.signal
            })
                .then((response) => {
                const patchResult = response.data.data;
                const processedData = patchResult.map((event) => processGenericEvent(event));
                setResult(processedData);
            })
                .catch((err) => {
                if (!controller.signal.aborted) {
                    setResult(undefined);
                    setError(err);
                }
            })
                .finally(() => {
                if (!controller.signal.aborted)
                    setSaving(false);
            });
        });
    }, [processGenericEvent]);
    return { save, saving, error, result };
}
export default usePatchGenericEvent;
